import {
  ADD_SELECTED_ATTACHED_FILE,
  ADD_SELECTED_OBSERVERS_GROUPS,
  ADD_SELECTED_OBSERVERS_MEMBERS,
  ADD_SELECTED_RESPONSIBLES_GROUPS,
  ADD_SELECTED_RESPONSIBLES_MEMBERS,
  ADD_SELECTED_VALIDATORS_GROUPS,
  ADD_SELECTED_VALIDATORS_MEMBERS,
  REMOVE_DELETE_TASK_COMMENT_PENDING,
  REMOVE_POST_TASK_COMMENT_PENDING,
  REMOVE_TASK_DETAILS_PENDING,
  REMOVE_SELECTED_ATTACHED_FILE,
  REMOVE_SELECTED_OBSERVERS_GROUPS,
  REMOVE_SELECTED_OBSERVERS_MEMBERS,
  REMOVE_SELECTED_RESPONSIBLES_GROUPS,
  REMOVE_SELECTED_RESPONSIBLES_MEMBERS,
  REMOVE_SELECTED_VALIDATORS_GROUPS,
  REMOVE_SELECTED_VALIDATORS_MEMBERS,
  REMOVE_TASK_COMMENTS_PENDING,
  REMOVE_PANE_TASK_DETAILS_PENDING,
  REMOVE_TASK_RIGHTS_PENDING,
  REMOVE_TASK_FOLDER_PENDING,
  RESET_ATTACHED_FILE_VERSIONS,
  RESET_CHECKLIST,
  RESET_ROLE_PICKER,
  RESET_SELECTED_ATTACHED_FILE,
  RESET_TASK_FOLDER,
  SET_ATTACHED_FILE_VERSIONS,
  SET_ATTACHED_FILE_VERSIONS_ERROR,
  SET_ATTACHED_FILE_VERSIONS_PENDING,
  SET_CHECKLIST_STRUCTURE,
  SET_CHECKLIST_PENDING,
  SET_CHECKLIST_DETAILS_PENDING,
  SET_CHECKLIST_TABLE_HEADER,
  SET_CONTACT_RESPONSIBLE_ERROR,
  SET_CONTACT_RESPONSIBLE_PENDING,
  SET_CREATE_TASK_ERROR,
  SET_CREATE_TASK_PENDING,
  SET_CREATE_SECTION_PENDING,
  SET_DELETE_FILDERS_ERROR,
  SET_DELETE_FILDERS_PENDING,
  SET_DELETE_SAVED_CHECKLIST_PENDING,
  SET_DELETE_SAVED_CHECKLIST_ERROR,
  SET_SHARE_SAVED_CHECKLIST_PENDING,
  SET_SHARE_SAVED_CHECKLIST_ERROR,
  SET_RENAME_SAVED_CHECKLIST_PENDING,
  SET_RENAME_SAVED_CHECKLIST_ERROR,
  SET_DELETE_TABLE_SELECTION_ERROR,
  SET_DELETE_CHECKLIST_DOUBLE_VALIDATION_PENDING,
  SET_DELETE_TABLE_SELECTION_PENDING,
  SET_DELETE_TASK_COMMENT_ERROR,
  SET_DELETE_TASK_COMMENT_PENDING,
  SET_DELETE_TASK_ERROR,
  SET_DELETE_TASK_MODAL,
  SET_DELETE_TASK_PENDING,
  SET_DELETE_SECTION_PENDING,
  SET_DUPLICATE_TASK_ERROR,
  SET_DUPLICATE_TASK_PENDING,
  SET_EDIT_TASK,
  SET_EDIT_TASK_PENDING,
  SET_EDIT_SECTION,
  SET_EDIT_SECTION_PENDING,
  SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN,
  SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN,
  SET_CHECKLISTS_TEMPLATES_SELECTED_TAB,
  SET_IMPORT_CHECKLIST_FROM_CLOSD_ERROR,
  SET_IMPORT_CHECKLIST_FROM_CLOSD_PENDING,
  SET_IMPORT_CHECKLIST_FROM_EXCEL_PENDING,
  SET_LAST_ITEM_ADDED,
  SET_MOVE_FILDERS_ERROR,
  SET_MOVE_FILDERS_PENDING,
  SET_CHECKLIST_SHARE_BY_EMAIL_PANE,
  SET_CHECKLIST_SHARE_BY_EMAIL_PANE_TAB,
  SET_PARENT_CHILDREN,
  SET_POST_ATTACHED_FILE_VERSIONS_ERROR,
  SET_POST_ATTACHED_FILE_VERSIONS_PENDING,
  SET_MOVE_ITEMS_PENDING,
  SET_POST_STATUS_ERROR,
  SET_POST_STATUS_PENDING,
  SET_POST_TASK_COMMENT_ERROR,
  SET_POST_TASK_COMMENT_PENDING,
  SET_TASK_DETAILS,
  SET_TASK_DETAILS_PENDING,
  SET_RENAME_ATTACHED_FILE_DIALOG,
  SET_RENAME_ATTACHED_FILE_ERROR,
  SET_RENAME_ATTACHED_FILE_PENDING,
  SET_SAVED_CHECKLISTS,
  SET_SAVED_CHECKLISTS_ERROR,
  SET_SAVED_CHECKLISTS_PENDING,
  SET_SELF_SAVED_CHECKLISTS_PENDING,
  SET_SELF_SAVED_CHECKLISTS,
  SET_SELECTED_SELF_SAVED_CHECKLIST,
  SET_SELECTED_SAVED_CHECKLIST,
  SET_SAVED_CHECKLIST_PREVIEW,
  SET_SAVED_CHECKLIST_PREVIEW_PENDING,
  SET_SAVED_CHECKLIST_PREVIEW_ERROR,
  SET_LEXISNEXIS_CHECKLISTS,
  SET_LEXISNEXIS_CHECKLISTS_ERROR,
  SET_LEXISNEXIS_CHECKLISTS_PENDING,
  SET_SELECTED_LEXISNEXIS_CHECKLIST,
  SET_LEXISNEXIS_CHECKLIST_PREVIEW,
  SET_LEXISNEXIS_CHECKLIST_PREVIEW_PENDING,
  SET_LEXISNEXIS_CHECKLIST_PREVIEW_ERROR,
  SET_SAVE_CHECKLIST_DIALOG_IS_OPEN,
  SET_SAVE_CHECKLIST_ERROR,
  SET_SAVE_CHECKLIST_PENDING,
  SET_UPDATE_CHECKLIST_PENDING,
  SET_SELECTED_ATTACHED_FILE,
  SET_SELECTED_TASKS,
  SET_SELECTED_SECTIONS,
  SET_SHARE_ATTACHED_FILES_ERROR,
  SET_SHARE_ATTACHED_FILES_PENDING,
  SET_SHARE_CHECKLIST_BY_EMAIL_PENDING,
  SET_SHARE_TASKS_DIALOG,
  SET_SHARE_TASKS_ERROR,
  SET_SHARE_TASKS_PENDING,
  SET_TABLE_TASK_PANE,
  SET_TABLE_TASK_PANE_TAB,
  SET_TASK_COMMENTS_ERROR,
  SET_TASK_COMMENTS_PENDING,
  SET_PANE_TASK_DETAILS_PENDING,
  SET_TASK_RIGHTS_PENDING,
  SET_TASK_FOLDER,
  SET_TASK_FOLDER_ERROR,
  SET_TASK_FOLDER_PENDING,
  SET_TASK_STATUS_CATEGORIES,
  SET_TASK_STATUS_CATEGORIES_ERROR,
  SET_TASK_STATUS_CATEGORIES_PENDING,
  TOGGLE_SELECTED_OBSERVERS_GROUPS,
  TOGGLE_SELECTED_OBSERVERS_MEMBERS,
  TOGGLE_SELECTED_RESPONSIBLES_GROUPS,
  TOGGLE_SELECTED_RESPONSIBLES_MEMBERS,
  TOGGLE_SELECTED_VALIDATORS_GROUPS,
  TOGGLE_SELECTED_VALIDATORS_MEMBERS,
  SET_SECTIONS_EXPAND_STATE,
  REMOVE_FROM_EXPAND_TASK_AFTER_DELETE,
  REMOVE_CHECKLIST_FILTER,
  SET_CHECKLIST_FILTERS,
  SET_FILTERS_PANE_IS_OPEN,
  SET_SEARCH_QUERY,
  SET_GLOBAL_TASK_FOLDER_PENDING,
  SET_GLOBAL_TASK_FOLDER,
  SET_GLOBAL_ATTACHED_FILES_DIALOG_IS_OPEN,
  SET_DOWNLOAD_TODO_FILES_PENDING,
  SET_CHECKLIST_VERSIONING_PANE_TAB,
  TOGGLE_CHECKLIST_VERSIONING_PANE,
  SET_CHECKLIST_PANE,
  SET_CHECKLIST_PANE_TAB,
  SET_CHECKLIST_PANE_TASKS,
  SET_CHECKLIST_TASKS_DETAILS,
  SET_CHECKLIST_SECTIONS_DETAILS,
  SET_CHECKLIST_LAST_UPDATE_DATE,
  SET_CHECKLIST_TITLE_INPUT_INVALID,
  REMOVE_CHECKLIST_SECTIONS_DETAILS,
  REMOVE_CHECKLIST_TASKS_DETAILS,
  ADD_CHECKLIST_ITEM_BEING_EDITED,
  REMOVE_CHECKLIST_ITEM_BEING_EDITED,
  SET_CHECKLIST_DRAG_ITEM,
  SET_CHECKLIST_DRAG_OVER_SECTION,
  SET_CHECKLIST_PRISTINE,
  SET_UPDATE_TASK_STATUSES_PENDING,
  REMOVE_UPDATE_TASK_STATUSES_PENDING,
} from './mutation_types'

export const mutations = {
  [SET_GLOBAL_ATTACHED_FILES_DIALOG_IS_OPEN] (state, value) {
    state.globalAttachedFilesDialogIsOpen = value
  },
  [SET_DELETE_TASK_MODAL] (state, value) {
    state.deleteTaskModal = value
  },
  [SET_SELECTED_TASKS] (state, tasks) {
    state.selectedChecklistItems.tasks = tasks
  },
  [SET_SELECTED_SECTIONS] (state, sections) {
    state.selectedChecklistItems.sections = sections
  },
  [SET_DELETE_CHECKLIST_DOUBLE_VALIDATION_PENDING] (state, value) {
    state.deleteChecklistDoubleValidationPending = value
  },
  [SET_DELETE_TABLE_SELECTION_PENDING] (state, value) {
    state.deleteTableSelectionPending = value
  },
  [SET_DELETE_TABLE_SELECTION_ERROR] (state, value) {
    state.deleteTableSelectionError = value
  },
  [SET_CHECKLIST_PENDING] (state, value) {
    state.checklistPending = value
  },
  [SET_CHECKLIST_DETAILS_PENDING] (state, value) {
    state.checklistDetailsPending = value
  },
  [SET_CHECKLIST_STRUCTURE] (state, value) {
    state.checklistStructure = value
  },
  [SET_CHECKLIST_SECTIONS_DETAILS] (state, sectionsDetails) {
    sectionsDetails.forEach(sectionDetails => {
      state.checklistDetails.sections[sectionDetails.id] = {
        ...state.checklistDetails.sections[sectionDetails.id],
        ...sectionDetails,
      }
    })
  },
  [REMOVE_CHECKLIST_SECTIONS_DETAILS] (state, sections) {
    sections.forEach(section => delete state.checklistDetails.sections[section.id])
  },
  [SET_CHECKLIST_TASKS_DETAILS] (state, tasksDetails) {
    tasksDetails.forEach(taskDetails => {
      state.checklistDetails.tasks[taskDetails.id] = {
        ...state.checklistDetails.tasks[taskDetails.id],
        ...taskDetails,
      }
    })
  },
  [REMOVE_CHECKLIST_TASKS_DETAILS] (state, tasks) {
    tasks.forEach(task => delete state.checklistDetails.tasks[task.id])
  },
  [SET_CHECKLIST_LAST_UPDATE_DATE] (state, lastUpdateDate) {
    state.checklistLastUpdateDate = lastUpdateDate
  },
  [SET_CHECKLIST_TITLE_INPUT_INVALID] (state, value) {
    state.checklistTitleInputInvalid = value
  },
  [ADD_CHECKLIST_ITEM_BEING_EDITED] (state, item) {
    state.checklistItemsBeingEdited.push(item)
  },
  [REMOVE_CHECKLIST_ITEM_BEING_EDITED] (state, item) {
    state.checklistItemsBeingEdited = state.checklistItemsBeingEdited.filter(
      ({ type, id }) => item.type !== type && item.id !== id,
    )
  },
  [RESET_CHECKLIST] (state) {
    state.checklistStructure = []
    state.checklistDetails = {
      sections: {},
      tasks: {},
    }
    state.checklistLastUpdateDate = null
    state.importChecklistDialogIsOpen = null
    state.importChecklistFromTemplateDialogIsOpen = false
    state.lastItemAdded = null
    state.saveChecklistDialogIsOpen = null
    state.savedChecklists = []
    state.lexisNexisChecklists = []
    state.searchQuery = ''
    state.checklistItemsBeingEdited = []
  },
  [SET_CHECKLIST_TABLE_HEADER] (state, value) {
    state.checklistTableHeader = value
  },
  [SET_CREATE_TASK_PENDING] (state, value) {
    state.createTaskPending = value
  },
  [SET_CREATE_TASK_ERROR] (state, value) {
    state.createTaskError = value
  },
  [SET_EDIT_TASK] (state, task) {
    state.checklistDetails.tasks[task.id] = task
  },
  [SET_EDIT_TASK_PENDING] (state, value) {
    state.editTaskPending = value
  },
  [SET_DOWNLOAD_TODO_FILES_PENDING] (state, value) {
    state.downloadTodoFilesPending = value
  },
  [SET_GLOBAL_TASK_FOLDER_PENDING] (state, value) {
    state.globalTaskFolderPending = value
  },
  [SET_GLOBAL_TASK_FOLDER] (state, value) {
    state.globalTaskFolder = value
  },
  [SET_EDIT_SECTION] (state, section) {
    state.checklistDetails.sections[section.id] = section
  },
  [SET_EDIT_SECTION_PENDING] (state, value) {
    state.editSectionPending = value
  },
  [SET_DELETE_SECTION_PENDING] (state, value) {
    state.deleteSectionPending = value
  },
  [SET_CREATE_SECTION_PENDING] (state, value) {
    state.createSectionPending = value
  },
  [SET_SHARE_TASKS_DIALOG] (state, value) {
    state.shareTasksDialog = value
  },
  [TOGGLE_SELECTED_RESPONSIBLES_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedResponsibles.members.findIndex(item => item.id === member.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedResponsibles.members.splice(index, 1)
    } else {
      state.shareTaskRolePickerSelectedResponsibles.members.push(member)
    }
  },
  [ADD_SELECTED_RESPONSIBLES_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedResponsibles.members.findIndex(item => item.id === member.id)
    if (index < 0) {
      state.shareTaskRolePickerSelectedResponsibles.members.push(member)
    }
  },
  [REMOVE_SELECTED_RESPONSIBLES_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedResponsibles.members.findIndex(item => item.id === member.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedResponsibles.members.splice(index, 1)
    }
  },
  [TOGGLE_SELECTED_OBSERVERS_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedObservers.members.findIndex(item => item.id === member.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedObservers.members.splice(index, 1)
    } else {
      state.shareTaskRolePickerSelectedObservers.members.push(member)
    }
  },
  [ADD_SELECTED_OBSERVERS_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedObservers.members.findIndex(item => item.id === member.id)
    if (index < 0) {
      state.shareTaskRolePickerSelectedObservers.members.push(member)
    }
  },
  [REMOVE_SELECTED_OBSERVERS_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedObservers.members.findIndex(item => item.id === member.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedObservers.members.splice(index, 1)
    }
  },
  [TOGGLE_SELECTED_VALIDATORS_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedValidators.members.findIndex(item => item.id === member.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedValidators.members.splice(index, 1)
    } else {
      state.shareTaskRolePickerSelectedValidators.members.push(member)
    }
  },
  [ADD_SELECTED_VALIDATORS_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedValidators.members.findIndex(item => item.id === member.id)
    if (index < 0) {
      state.shareTaskRolePickerSelectedValidators.members.push(member)
    }
  },
  [REMOVE_SELECTED_VALIDATORS_MEMBERS] (state, member) {
    const index = state.shareTaskRolePickerSelectedValidators.members.findIndex(item => item.id === member.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedValidators.members.splice(index, 1)
    }
  },
  [TOGGLE_SELECTED_RESPONSIBLES_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedResponsibles.groups.findIndex(item => item.id === group.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedResponsibles.groups.splice(index, 1)
    } else {
      state.shareTaskRolePickerSelectedResponsibles.groups.push(group)
    }
  },
  [ADD_SELECTED_RESPONSIBLES_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedResponsibles.groups.findIndex(item => item.id === group.id)
    if (index < 0) {
      state.shareTaskRolePickerSelectedResponsibles.groups.push(group)
    }
  },
  [REMOVE_SELECTED_RESPONSIBLES_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedResponsibles.groups.findIndex(item => item.id === group.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedResponsibles.groups.splice(index, 1)
    }
  },
  [TOGGLE_SELECTED_OBSERVERS_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedObservers.groups.findIndex(item => item.id === group.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedObservers.groups.splice(index, 1)
    } else {
      state.shareTaskRolePickerSelectedObservers.groups.push(group)
    }
  },
  [ADD_SELECTED_OBSERVERS_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedObservers.groups.findIndex(item => item.id === group.id)
    if (index < 0) {
      state.shareTaskRolePickerSelectedObservers.groups.push(group)
    }
  },
  [REMOVE_SELECTED_OBSERVERS_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedObservers.groups.findIndex(item => item.id === group.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedObservers.groups.splice(index, 1)
    }
  },
  [TOGGLE_SELECTED_VALIDATORS_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedValidators.groups.findIndex(item => item.id === group.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedValidators.groups.splice(index, 1)
    } else {
      state.shareTaskRolePickerSelectedValidators.groups.push(group)
    }
  },
  [ADD_SELECTED_VALIDATORS_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedValidators.groups.findIndex(item => item.id === group.id)
    if (index < 0) {
      state.shareTaskRolePickerSelectedValidators.groups.push(group)
    }
  },
  [REMOVE_SELECTED_VALIDATORS_GROUPS] (state, group) {
    const index = state.shareTaskRolePickerSelectedValidators.groups.findIndex(item => item.id === group.id)
    if (index >= 0) {
      state.shareTaskRolePickerSelectedValidators.groups.splice(index, 1)
    }
  },
  [SET_SHARE_TASKS_PENDING] (state, value) {
    state.shareTasksPending = value
  },
  [SET_SHARE_TASKS_ERROR] (state, value) {
    state.shareTasksError = value
  },
  [RESET_ROLE_PICKER] (state) {
    state.shareTaskRolePickerGroups = null
    state.shareTaskRolePickerSelectedResponsibles = {
      groups: [],
      members: [],
    }
    state.shareTaskRolePickerSelectedObservers = {
      groups: [],
      members: [],
    }
    state.shareTaskRolePickerSelectedValidators = {
      groups: [],
      members: [],
    }
  },
  [SET_SAVE_CHECKLIST_DIALOG_IS_OPEN] (state, value) {
    state.saveChecklistDialogIsOpen = value
  },
  [SET_SAVE_CHECKLIST_PENDING] (state, value) {
    state.saveChecklistPending = value
  },
  [SET_UPDATE_CHECKLIST_PENDING] (state, value) {
    state.updateChecklistPending = value
  },
  [SET_SAVE_CHECKLIST_ERROR] (state, value) {
    state.saveChecklistError = value
  },
  [SET_IMPORT_CHECKLIST_DIALOG_IS_OPEN] (state, value) {
    state.importChecklistDialogIsOpen = value
  },
  [SET_IMPORT_CHECKLIST_FROM_TEMPLATE_DIALOG_IS_OPEN] (state, value) {
    state.importChecklistFromTemplateDialogIsOpen = value
  },
  [SET_CHECKLISTS_TEMPLATES_SELECTED_TAB] (state, value) {
    state.checklistTemplatesSelectedTab = value
  },
  [SET_SAVED_CHECKLISTS_PENDING] (state, value) {
    state.savedChecklistsPending = value
  },
  [SET_SAVED_CHECKLISTS] (state, value) {
    state.savedChecklists = value
  },
  [SET_SELF_SAVED_CHECKLISTS_PENDING] (state, value) {
    state.selfSavedChecklistsPending = value
  },
  [SET_SELF_SAVED_CHECKLISTS] (state, value) {
    state.selfSavedChecklists = value
  },
  [SET_SELECTED_SELF_SAVED_CHECKLIST] (state, value) {
    state.selectedSelfSavedChecklist = value
  },
  [SET_SAVED_CHECKLISTS_ERROR] (state, value) {
    state.savedChecklistsError = value
  },
  [SET_SELECTED_SAVED_CHECKLIST] (state, value) {
    state.selectedSavedChecklist = value
  },
  [SET_SAVED_CHECKLIST_PREVIEW_PENDING] (state, value) {
    state.savedChecklistPreviewPending = value
  },
  [SET_SAVED_CHECKLIST_PREVIEW] (state, value) {
    state.savedChecklistPreview = value
  },
  [SET_SAVED_CHECKLIST_PREVIEW_ERROR] (state, value) {
    state.savedChecklistPreviewError = value
  },
  [SET_LEXISNEXIS_CHECKLISTS_PENDING] (state, value) {
    state.lexisNexisChecklistsPending = value
  },
  [SET_LEXISNEXIS_CHECKLISTS] (state, value) {
    state.lexisNexisChecklists = value
  },
  [SET_LEXISNEXIS_CHECKLISTS_ERROR] (state, value) {
    state.lexisNexisChecklistsError = value
  },
  [SET_SELECTED_LEXISNEXIS_CHECKLIST] (state, value) {
    state.selectedLexisNexisChecklist = value
  },
  [SET_LEXISNEXIS_CHECKLIST_PREVIEW_PENDING] (state, value) {
    state.lexisNexisChecklistPreviewPending = value
  },
  [SET_LEXISNEXIS_CHECKLIST_PREVIEW] (state, value) {
    state.lexisNexisChecklistPreview = value
  },
  [SET_LEXISNEXIS_CHECKLIST_PREVIEW_ERROR] (state, value) {
    state.lexisNexisChecklistPreviewError = value
  },
  [SET_IMPORT_CHECKLIST_FROM_CLOSD_PENDING] (state, value) {
    state.importChecklistFromClosdPending = value
  },
  [SET_IMPORT_CHECKLIST_FROM_EXCEL_PENDING] (state, value) {
    state.importChecklistFromExcelPending = value
  },
  [SET_IMPORT_CHECKLIST_FROM_CLOSD_ERROR] (state, value) {
    state.importChecklistFromClosdError = value
  },
  [SET_DELETE_SAVED_CHECKLIST_PENDING] (state, value) {
    state.deleteSavedChecklistPending = value
  },
  [SET_DELETE_SAVED_CHECKLIST_ERROR] (state, value) {
    state.deleteSavedChecklistError = value
  },
  [SET_SHARE_SAVED_CHECKLIST_PENDING] (state, value) {
    state.shareSavedChecklistPending = value
  },
  [SET_SHARE_SAVED_CHECKLIST_ERROR] (state, value) {
    state.shareSavedChecklistError = value
  },
  [SET_RENAME_SAVED_CHECKLIST_PENDING] (state, value) {
    state.renameSavedChecklistPending = value
  },
  [SET_RENAME_SAVED_CHECKLIST_ERROR] (state, value) {
    state.renameSavedChecklistError = value
  },
  [SET_LAST_ITEM_ADDED] (state, value) {
    state.lastItemAdded = value
  },
  [SET_TASK_COMMENTS_PENDING] (state, value) {
    state.taskCommentsPendingIds.push(value)
  },
  [SET_PANE_TASK_DETAILS_PENDING] (state, value) {
    state.paneTaskDetailsPendingIds.push(value)
  },
  [SET_TASK_RIGHTS_PENDING] (state, value) {
    state.taskRightsPendingIds.push(value)
  },
  [REMOVE_TASK_COMMENTS_PENDING] (state, index) {
    state.taskCommentsPendingIds.splice(index, 1)
  },
  [REMOVE_PANE_TASK_DETAILS_PENDING] (state, index) {
    state.paneTaskDetailsPendingIds.splice(index, 1)
  },
  [REMOVE_TASK_RIGHTS_PENDING] (state, index) {
    state.taskRightsPendingIds.splice(index, 1)
  },
  [SET_TASK_COMMENTS_ERROR] (state, value) {
    state.taskCommentsError = value
  },
  [SET_POST_TASK_COMMENT_PENDING] (state, value) {
    state.postTaskCommentPendingIds.push(value)
  },
  [REMOVE_POST_TASK_COMMENT_PENDING] (state, index) {
    state.postTaskCommentPendingIds.splice(index, 1)
  },
  [SET_POST_TASK_COMMENT_ERROR] (state, value) {
    state.postTaskCommentError = value
  },
  [SET_DELETE_TASK_COMMENT_PENDING] (state, value) {
    state.deleteTaskCommentPendingIds.push(value)
  },
  [REMOVE_DELETE_TASK_COMMENT_PENDING] (state, index) {
    state.deleteTaskCommentPendingIds.splice(index, 1)
  },
  [SET_DELETE_TASK_COMMENT_ERROR] (state, value) {
    state.deleteTaskCommentError = value
  },
  [SET_DELETE_TASK_PENDING] (state, value) {
    state.deleteTaskPending = value
  },
  [SET_DELETE_TASK_ERROR] (state, value) {
    state.deleteTaskError = value
  },
  [SET_CONTACT_RESPONSIBLE_PENDING] (state, value) {
    state.contactResponsiblePending = value
  },
  [SET_CONTACT_RESPONSIBLE_ERROR] (state, value) {
    state.contactResponsibleError = value
  },
  [SET_TASK_STATUS_CATEGORIES_PENDING] (state, value) {
    state.taskStatusCategoriesPending = value
  },
  [SET_TASK_STATUS_CATEGORIES] (state, statusCategories) {
    state.taskStatusCategories = statusCategories.reduce(
      (result, category) => {
        result[category.name] = category.statuses
        return result
      },
      {},
    )
  },
  [SET_TASK_STATUS_CATEGORIES_ERROR] (state, value) {
    state.taskStatusCategoriesError = value
  },
  [SET_MOVE_ITEMS_PENDING] (state, value) {
    state.moveItemsPending = value
  },
  [SET_PARENT_CHILDREN] (state, payload) {
    payload.parent.children = payload.children
  },
  [SET_TASK_FOLDER_PENDING] (state, value) {
    state.taskFolderPendingIds.push(value)
  },
  [SET_TASK_FOLDER] (state, value) {
    state.currentTaskFolder = value
  },
  [RESET_TASK_FOLDER] (state) {
    state.currentTaskFolder = null
  },
  [REMOVE_TASK_FOLDER_PENDING] (state, index) {
    state.taskFolderPendingIds.splice(index, 1)
  },
  [SET_TASK_FOLDER_ERROR] (state, value) {
    state.taskFolderError = value
  },
  [SET_CHECKLIST_SHARE_BY_EMAIL_PANE] (state, value) {
    state.checklistShareByEmailPane = value
  },
  [SET_CHECKLIST_SHARE_BY_EMAIL_PANE_TAB] (state, value) {
    state.checklistShareByEmailPane.tab = value
  },
  [SET_SHARE_ATTACHED_FILES_PENDING] (state, value) {
    state.shareAttachedFilesPending = value
  },
  [SET_SHARE_ATTACHED_FILES_ERROR] (state, value) {
    state.shareAttachedFilesError = value
  },
  [SET_MOVE_FILDERS_PENDING] (state, value) {
    state.moveFildersPending = value
  },
  [SET_MOVE_FILDERS_ERROR] (state, value) {
    state.moveFildersError = value
  },
  [SET_DELETE_FILDERS_PENDING] (state, value) {
    state.deleteFildersPending = value
  },
  [SET_DELETE_FILDERS_ERROR] (state, value) {
    state.deleteFildersError = value
  },
  [SET_RENAME_ATTACHED_FILE_DIALOG] (state, value) {
    state.renameAttachedFilesDialog = value
  },
  [SET_RENAME_ATTACHED_FILE_PENDING] (state, value) {
    state.renameAttachedFilePending = value
  },
  [SET_RENAME_ATTACHED_FILE_ERROR] (state, value) {
    state.renameAttachedFileError = value
  },
  [SET_ATTACHED_FILE_VERSIONS_PENDING] (state, value) {
    state.attachedFileVersionsPending = value
  },
  [SET_ATTACHED_FILE_VERSIONS] (state, value) {
    state.attachedFileVersions = value
  },
  [RESET_ATTACHED_FILE_VERSIONS] (state) {
    state.attachedFileVersions = null
  },
  [SET_ATTACHED_FILE_VERSIONS_ERROR] (state, value) {
    state.attachedFileVersionsError = value
  },
  [SET_POST_ATTACHED_FILE_VERSIONS_PENDING] (state, value) {
    state.postAttachedFileVersionsPending = value
  },
  [SET_POST_ATTACHED_FILE_VERSIONS_ERROR] (state, value) {
    state.postAttachedFileVersionsError = value
  },
  [SET_SELECTED_ATTACHED_FILE] (state, value) {
    const itemIndex = state.selectedAttachedFiles.findIndex(item => item.id === value.id)
    itemIndex >= 0
      ? state.selectedAttachedFiles.splice(itemIndex, 1)
      : state.selectedAttachedFiles.push(value)
  },
  [ADD_SELECTED_ATTACHED_FILE] (state, value) {
    const itemIndex = state.selectedAttachedFiles.findIndex(item => item.id === value.id)
    if (itemIndex < 0) {
      state.selectedAttachedFiles.push(value)
    }
  },
  [REMOVE_SELECTED_ATTACHED_FILE] (state, value) {
    const itemIndex = state.selectedAttachedFiles.findIndex(item => item.id === value.id)
    if (itemIndex >= 0) {
      state.selectedAttachedFiles.splice(itemIndex, 1)
    }
  },
  [RESET_SELECTED_ATTACHED_FILE] (state) {
    state.selectedAttachedFiles = []
  },
  [SET_TASK_DETAILS_PENDING] (state, value) {
    state.taskDetailsPendingIds.push(value)
  },
  [REMOVE_TASK_DETAILS_PENDING] (state, index) {
    state.taskDetailsPendingIds.splice(index, 1)
  },
  [SET_TASK_DETAILS] (state, task) {
    state.checklistDetails.tasks[task.id] = task
  },
  [SET_DUPLICATE_TASK_PENDING] (state, value) {
    state.duplicateTaskPending = value
  },
  [SET_DUPLICATE_TASK_ERROR] (state, value) {
    state.duplicateTaskError = value
  },
  [SET_POST_STATUS_PENDING] (state, value) {
    state.postStatusPending = value
  },
  [SET_POST_STATUS_ERROR] (state, value) {
    state.postStatusError = value
  },
  [SET_TABLE_TASK_PANE] (state, value) {
    state.tableTaskPane = value
  },
  [SET_TABLE_TASK_PANE_TAB] (state, value) {
    state.tableTaskPane.tab = value
  },
  [REMOVE_FROM_EXPAND_TASK_AFTER_DELETE] (state, sectionId) {
    const item = state.sectionsExpandState.findIndex(item => item.id === sectionId)
    if (item >= 0) {
      state.sectionsExpandState.splice(item, 1)
    }
  },
  [SET_SHARE_CHECKLIST_BY_EMAIL_PENDING] (state, value) {
    state.shareChecklistByEmailPending = value
  },
  [SET_SECTIONS_EXPAND_STATE] (state, sectionsExpandState) {
    state.sectionsExpandState = sectionsExpandState
  },
  // Filters
  [REMOVE_CHECKLIST_FILTER] (state, filterToRemove) {
    state.filters = state.filters.filter(
      filter => filter.category.key !== filterToRemove.category.key || filter.value.key !== filterToRemove.value.key,
    )
  },
  [SET_CHECKLIST_FILTERS] (state, value) {
    state.filters = value
  },
  [SET_FILTERS_PANE_IS_OPEN] (state, isOpen) {
    state.filtersPaneIsOpen = isOpen
  },
  // Search
  [SET_SEARCH_QUERY] (state, searchQuery) {
    state.searchQuery = searchQuery
  },
  [SET_CHECKLIST_VERSIONING_PANE_TAB] (state, tab) {
    state.checklistVersioningPane.tab = tab
  },
  [TOGGLE_CHECKLIST_VERSIONING_PANE] (state, payload) {
    state.checklistVersioningPane.documentVersions = payload.documentVersions || []
    state.checklistVersioningPane.documents = payload.documents || []
    state.checklistVersioningPane.isOpen = payload.isOpen || false
    state.checklistVersioningPane.tab = payload.tab || ''
  },
  [SET_CHECKLIST_PANE] (state, payload) {
    state.checklistPane.isOpen = payload.isOpen || false
    state.checklistPane.parent = payload.parent || null
    state.checklistPane.tab = payload.tab || null
    state.checklistPane.tasks = payload.tasks || []
  },
  [SET_CHECKLIST_PANE_TAB] (state, tab) {
    state.checklistPane.tab = tab
  },
  [SET_CHECKLIST_PANE_TASKS] (state, tasks) {
    state.checklistPane.tasks = tasks
  },
  [SET_CHECKLIST_DRAG_ITEM] (state, item) {
    state.checklistDragItem = item
  },
  [SET_CHECKLIST_PRISTINE] (state, value) {
    state.checklistPristine = value
  },
  [SET_CHECKLIST_DRAG_OVER_SECTION] (state, section) {
    state.checklistDragOverSection = section
  },
  [SET_UPDATE_TASK_STATUSES_PENDING] (state, tasksIds) {
    state.updateTaskStatusesPending.push(...tasksIds)
  },
  [REMOVE_UPDATE_TASK_STATUSES_PENDING] (state, tasksIds) {
    state.updateTaskStatusesPending = state.updateTaskStatusesPending.filter(id => !tasksIds.includes(id))
  },
}
